import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, Grid, useTheme, useMediaQuery, Card, CardContent, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tabs, Tab } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
interface MakerInboxProps {
  onLogout: () => void;
}
interface RecordData {
  id: number;
  fullName: string;
  username: string;
  email: string;
  mobile: string;
  currency: string;
  branchCode: string;
  settlementAccount: string;
  designation: string;
  batchId: string;
  fileName: string;
  submittedAt: string;
  approvalStatus: 'pending' | 'completed' | 'rejected';
  checkerReason?: string;
  checkedAt?: string;
}
export default function MakerInbox({
  onLogout
}: MakerInboxProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [records, setRecords] = useState<RecordData[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(() => {
    // Load records from localStorage
    const storedRecords = JSON.parse(localStorage.getItem('makerInboxRecords') || '[]');
    setRecords(storedRecords);
    // Set up an interval to refresh records every 2 seconds to catch updates
    const interval = setInterval(() => {
      const updatedRecords = JSON.parse(localStorage.getItem('makerInboxRecords') || '[]');
      setRecords(updatedRecords);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const getFilteredRecords = () => {
    switch (activeTab) {
      case 0:
        return records.filter(r => r.approvalStatus === 'pending');
      case 1:
        return records.filter(r => r.approvalStatus === 'completed');
      case 2:
        return records.filter(r => r.approvalStatus === 'rejected');
      default:
        return records;
    }
  };
  const filteredRecords = getFilteredRecords();
  const renderRecordsTable = () => <TableContainer component={Paper} variant="outlined" data-id="element-4646">
      <Table data-id="element-4647">
        <TableHead data-id="element-4648">
          <TableRow data-id="element-4649">
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4650">
              Full Name
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4651">
              Username
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4652">
              Email
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4653">
              Mobile
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4654">
              Branch Code
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4655">
              Batch
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-4656">
              Status
            </TableCell>
            {activeTab !== 0 && <>
                <TableCell sx={{
              fontWeight: 600
            }} data-id="element-4657">
                  Checker Reason
                </TableCell>
                <TableCell sx={{
              fontWeight: 600
            }} data-id="element-4658">
                  Checked At
                </TableCell>
              </>}
          </TableRow>
        </TableHead>
        <TableBody data-id="element-4659">
          {filteredRecords.map(record => <TableRow key={record.id} hover data-id="element-4660">
              <TableCell data-id="element-4661">{record.fullName}</TableCell>
              <TableCell data-id="element-4662">{record.username}</TableCell>
              <TableCell data-id="element-4663">{record.email}</TableCell>
              <TableCell data-id="element-4664">{record.mobile}</TableCell>
              <TableCell data-id="element-4665">
                <Chip label={record.branchCode} size="small" sx={{
              backgroundColor: 'rgba(6, 182, 212, 0.1)',
              color: '#06B6D4',
              fontWeight: 600
            }} data-id="element-4666" />
              </TableCell>
              <TableCell data-id="element-4667">
                <Typography variant="body2" fontSize="0.85rem" data-id="element-4668">
                  {record.fileName}
                </Typography>
              </TableCell>
              <TableCell data-id="element-4669">
                <Chip label={record.approvalStatus === 'pending' ? 'Pending' : record.approvalStatus === 'completed' ? 'Completed' : 'Rejected'} size="small" sx={{
              backgroundColor: record.approvalStatus === 'pending' ? 'rgba(59, 130, 246, 0.1)' : record.approvalStatus === 'completed' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
              color: record.approvalStatus === 'pending' ? '#3B82F6' : record.approvalStatus === 'completed' ? '#10B981' : '#EF4444',
              fontWeight: 600
            }} data-id="element-4670" />
              </TableCell>
              {activeTab !== 0 && <>
                  <TableCell data-id="element-4671">
                    <Typography variant="body2" fontSize="0.85rem" data-id="element-4672">
                      {record.checkerReason || '-'}
                    </Typography>
                  </TableCell>
                  <TableCell data-id="element-4673">
                    <Typography variant="body2" fontSize="0.85rem" data-id="element-4674">
                      {record.checkedAt ? new Date(record.checkedAt).toLocaleDateString() : '-'}
                    </Typography>
                  </TableCell>
                </>}
            </TableRow>)}
          {filteredRecords.length === 0 && <TableRow data-id="element-4675">
              <TableCell colSpan={activeTab === 0 ? 7 : 9} align="center" sx={{
            py: 3
          }} data-id="element-4676">
                <Typography variant="body2" color="text.secondary" data-id="element-4677">
                  No records found
                </Typography>
              </TableCell>
            </TableRow>}
        </TableBody>
      </Table>
    </TableContainer>;
  return <Box sx={{
    width: '100%',
    height: '100%',
    bgcolor: 'background.default'
  }} data-id="element-4678">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-4679" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="maker-inbox" data-id="element-4680" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - ${240}px)`
      },
      ml: {
        xs: 0,
        sm: `${240}px`
      },
      mt: 8
    }} data-id="element-4681">
        <Container maxWidth="xl" data-id="element-4682">
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-4683">
            <Grid item xs={12} data-id="element-4684">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-4685">
                <Icon icon="lucide:inbox" width={24} height={24} color="#0EA5E9" data-id="element-4686" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-4687">
                  Maker Inbox
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Card data-id="element-4688">
            <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }} data-id="element-4689">
              <Tabs value={activeTab} onChange={handleTabChange} sx={{
              px: 3
            }} data-id="element-4690">
                <Tab label={<Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-4692">
                      <Typography variant="body2" fontWeight={500} data-id="element-4693">
                        Pending
                      </Typography>
                      <Chip label={records.filter(r => r.approvalStatus === 'pending').length} size="small" sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'rgba(59, 130, 246, 0.1)',
                  color: '#3B82F6'
                }} data-id="element-4694" />
                    </Box>} data-id="element-4691" />
                <Tab label={<Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-4696">
                      <Typography variant="body2" fontWeight={500} data-id="element-4697">
                        Completed
                      </Typography>
                      <Chip label={records.filter(r => r.approvalStatus === 'completed').length} size="small" sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'rgba(16, 185, 129, 0.1)',
                  color: '#10B981'
                }} data-id="element-4698" />
                    </Box>} data-id="element-4695" />
                <Tab label={<Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-4700">
                      <Typography variant="body2" fontWeight={500} data-id="element-4701">
                        Rejected
                      </Typography>
                      <Chip label={records.filter(r => r.approvalStatus === 'rejected').length} size="small" sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                  color: '#EF4444'
                }} data-id="element-4702" />
                    </Box>} data-id="element-4699" />
              </Tabs>
            </Box>
            <Box sx={{
            p: 3
          }} data-id="element-4703">
              {renderRecordsTable()}
            </Box>
          </Card>
        </Container>
      </Box>
    </Box>;
}